angular.module('eStories.promo', ['eStories.promo.model'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.50Off3Mo', {
                url: 'promo/:promoCode',
                views: {
                    'mainView@': {
                        templateUrl: 'home/promo/50Off3Mo.tmpl.html',
                        controller: 'PromoCtrl',
                        controllerAs: 'promoCtrl'
                    }
                }
            });
    }])
    .controller('PromoCtrl',
        ['CarouselService',
            'AccountModel',
            'PromoModel',
            '$location',
            'ModalsModel',
            'CatalogModel',
            'BillingModel',
            'CtaModel',
            '$stateParams',
            '$rootScope',
            '$state',
            'GA',
            function (CarouselService, AccountModel, PromoModel, $location, ModalsModel, CatalogModel, BillingModel,
                      CtaModel, $stateParams, $rootScope, $state, GA) {

                var promoCtrl = this;

                GA.trackPageView($location.path());

                promoCtrl.cta = CtaModel;
                promoCtrl.promo = PromoModel;
                promoCtrl.account = AccountModel;

                promoCtrl.shouldShowTabs = true;
                promoCtrl.shouldShowTabMenu = true;
                promoCtrl.shouldShowCTAUnderTable = true;

                promoCtrl.promoCode = $stateParams.promoCode;

                if (promoCtrl.promoCode === "6C6M2F3N8BDCF83F05E0A1BD1191E60") {
                    promoCtrl.is6CreditPromo = true;
                }

                promoCtrl.getArrayValue = function (index) {
                    return "/eStories/rest/catalog/getAudiobookCover?width=450&audiobookId=" + promoCtrl.audiobookIdArray[index];
                };

                promoCtrl.showPromoBar = function () {
                    var now = new Date();
                    var startDate = new Date(Date.UTC(2017, 11, 1, 5, 0));
                    var endDate = new Date(Date.UTC(2018, 0, 1, 0, 0));
                    return now > startDate && now < endDate;
                };

                if (PromoModel.promoIneligibile) {
                    return;
                }
                promoCtrl.showBar = false;

                promoCtrl.setPageMetaTags = function () {
                    $rootScope.titleValue = PromoModel.promoPackage.checkoutCopy + ' | ' + PromoModel.promoPackage.landingHeadlineCopy +
                        ' | eStories.com ';
                    $rootScope.titleContentValue = PromoModel.promoPackage.checkoutCopy + " | eStories.com";
                    $rootScope.descriptionContentValue = PromoModel.promoPackage.featureDescriptionCopy + " | Stream or download audiobooks to your computer, iPhone or Android.";
                    $rootScope.keywordsContentValue = "audiobook, audiobooks, free audiobook, free audiobooks, " +
                        "audio book, audio books, books online, ios books, android books, free audiobook, free";
                };


                $rootScope.$on('promoDetailsLoaded', function () {
                    promoCtrl.showBar = promoCtrl.account.isMember() &&
                        !promoCtrl.account.isTrialMember() &&
                        !promoCtrl.account.isFreemium;
                });

                $rootScope.$on('refreshPromoBar', function () {
                    promoCtrl.showBar = promoCtrl.account.isMember() &&
                        !promoCtrl.account.isTrialMember() &&
                        !promoCtrl.account.isFreemium;
                });


                if ($stateParams.promoCode) {
                    const promoDetailsPromoCode = $stateParams.promoCode === "GROUPON" ? "GROUPON" : $stateParams.promoCode;
                    let token = null;
                    if ($stateParams.promoCode === "GROUPON") {
                        token = $location.search().token;
                        PromoModel.tokenCode = token;
                    }
                    PromoModel.getPromoDetails(promoDetailsPromoCode, null, true,
                        token).then(response => {
                        if (response && response.responseStatus == "SUCCESS" && !PromoModel.promoIneligibile) {
                            PromoModel.isGrouponPurchase = $stateParams.promoCode === "GROUPON";
                            PromoModel.promoPackage = response.promotion;
                            PromoModel.promoCodeHash = $stateParams.promoCode === "GROUPON" ? token : $stateParams.promoCode;
                            promoCtrl.shouldShowTabs();
                            $rootScope.$broadcast('promoDetailsLoaded', response);
                            promoCtrl.setPageMetaTags()
                        } else {
                            $location.path('/');
                            AccountModel.promoFailMessage = PromoModel.parseFailedPromoMessage(response.responseText);
                            AccountModel.showEligibilityModal()
                        }
                    });
                }

                //check if landing sections map is cached
                $rootScope.$on('promoDetailsLoaded', async function () {
                    const response = await CatalogModel.getSectionList(['LANDING_FEATURE_CAROUSEL']);
                    var sectionList = response.sectionList;
                    promoCtrl.landingSectionsMap = {};
                    promoCtrl.landingSectionItemListMap = {};
                    for (var i = 0; i < sectionList.length; i++) {
                        var section = sectionList[i];
                        if (section.sectionType === 'FEATURE_PROMO' &&
                            PromoModel.hasPlanPromo() && section.promoName === PromoModel.promoPackage.name) {
                            promoCtrl.landingSectionsMap = [];
                            promoCtrl.landingSectionsMap.push(section);
                            break;
                        }
                    }
                });

                promoCtrl.shouldShowTabs = function () {
                    if (promoCtrl.promo.promoPackage.name === 'BASIC_MONTHLY') {
                        promoCtrl.visibleTab = "tab2";
                        promoCtrl.shouldShowTabMenu = false;
                        promoCtrl.shouldShowCTAUnderTable = false;
                        return false;
                    } else {
                        return true;
                    }
                };

                promoCtrl.visibleTab = "tab2";

            }]);